export enum PolitischeGemeindeSearchmode {
  GEOMETERGESCHAEFT_SEARCH,
  GEBAEUDE_SEARCH,
  GRUNDBUCHMELDUNG_REGISTER_SEARCH
}
